// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/computer.js';

import { paths } from '../generated/computer';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('computer', Original, paths);
